export const CampaignInfoPanelLoader = () => {
  return (
    <div className="campaignInfoPanel loading">
    </div>
  );
};
